import { NavigationCard } from "src/components/ui/navigation-card";
export const NavigationCards = () => {
  return (
    <>
      <NavigationCard
        label="Applied Posts"
        imageSrc="/application.png"
        href="/applied-posts"
      />
      <NavigationCard
        label="Your Books"
        imageSrc="/e-book.png"
        href="/books"
      />
    </>
  );
};
